<template>
  <v-dialog
    class="rss"
    v-if="dataUser.IndAutenticado"
    v-model="opendlg"
    persistent
    max-width="380"
  >
    <v-card class="elevation-12" color="warning" dark>
      <v-toolbar dark flat width="380" color="white">
        <v-toolbar-title>
          <v-img
            contain
            :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
            id="Home"
            width="154"
          ></v-img>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-btn icon @click="closedlg">
          <v-icon color="primary">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-alert type="error" v-if="dataUser.IndCambioClave" dense>
        Debes Cambiar la Contraseña
    </v-alert>
      <v-card-text class="text-center">
        <v-form id="login-form" ref="form">
          <v-text-field
            id="claveold"
            label="Contraseña Nueva"
            name="claveold"
            prepend-icon="mdi-lock"
            v-model="currentPassword"
            required
            :disabled="ProcessLogin"
            :append-icon="showoldpass ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showoldpass ? 'text' : 'password'"
            @click:append="showoldpass = !showoldpass"
            :rules="[
              () => !!currentPassword || 'Requerido',
              () => currentPassword.length >= 5 || 'Contraseña minimo 5 caracteres',
            ]"
          ></v-text-field>
          <v-text-field
            id="clavenew"
            label="Confirmar Contraseña"
            name="clavenew"
            prepend-icon="mdi-lock"
            v-model="newPassword"
            required
            @keyup.enter="login"
            :disabled="ProcessLogin"
            :append-icon="shownewpass ? 'mdi-eye' : 'mdi-eye-off'"
            :type="shownewpass ? 'text' : 'password'"
            @click:append="shownewpass = !shownewpass"
            :rules="[
              () => !!newPassword || 'Requerido',
              () => newPassword.length >= 5 || 'Contraseña minimo 5 caracteres',
              () =>
                newPassword === currentPassword ||
                'Las Contraseñas deben ser Iguales',
            ]"
          ></v-text-field>
          <v-alert
            v-if="msgResult.status"
            :class="['mx-auto', 'text-caption']"
            dense
            color="accent"
            width="200"
          >
            {{ msgResult.msg }}
          </v-alert>
        </v-form>
      </v-card-text>
      <v-progress-linear
        v-if="ProcessLogin"
        indeterminate
        color="secondary"
        class="mb-0"
      ></v-progress-linear>
      <v-divider color="#D3BC8D"></v-divider>
      <v-card-actions class="d-flex flex-row-reverse">
       
        <v-btn
          color="primary"
          elevation="0"
          @click="
            changePassword({
              passdid: currentPassword,
              checkpassdid: newPassword,
            })
          "
          :disabled="
            newPassword !== currentPassword ||
            (newPassword.length <= 5 && currentPassword.length <= 5)
          "
        >
          Cambiar
        </v-btn>
       
      </v-card-actions>
    </v-card></v-dialog
  >
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    opendlg: Boolean,
    closedlg: Function,
    dataUser: Object,
    keyId: Number,
  },

  data() {
    return {
      newPassword: "",
      currentPassword: "",
      shownewpass: false,
      showoldpass: false,
      ProcessLogin: false,
      msgResult: {
        status: false,
        msg: null,
      },
    };
  },
  computed: {
    ...mapState(["domoapi2_img", "dirPHP", "server_query"]),
  },
  methods: {
    ...mapMutations(["set_dataUser"]),
    async changePassword({ passdid, checkpassdid }) {
      try {
        const queryParams = new URLSearchParams({
          program: "ValidaUsuarioJson",
          usuario: this.dataUser.Usuario,
          clave1: window.btoa(passdid),
          clave2: window.btoa(checkpassdid),
          cambio: true,
        });
        this.ProcessLogin = true;

        const res = await fetch(
          `${this.dirPHP}${this.server_query}?${queryParams}`,
          {
            method: "GET",
          }
        );
        if (!res.ok) {
          throw new Error(`Error en la petición Fetch: ${res.status}`);
        }
        const jsonData = await res.json();
        const {
          dsValidaUsuario: { StatusJSon, wfusuario },
        } = jsonData;

        const { Notas, Procesado } = StatusJSon[0] || {};
        const [datosuser] = wfusuario;
        this.set_dataUser(datosuser);
        window.sessionStorage.setItem("datauser", JSON.stringify(datosuser));
        this.msgResult.status = Procesado;
        this.msgResult.msg = Notas;
        setTimeout(() => {
          this.closedlg();
        }, 1000);
      } catch (error) {
        console.error(error);
      } finally {
        this.ProcessLogin = false;
      }
    },
  },
};
</script>

<style></style>
